<template>

<v-dialog v-model="dialog" width="500px">
  <v-card>
    <p class=".title ma-2"> Booking.com hotel ID {{hsbc.hsbc_hotel_id}}</p>
    <p></p>
    
    <v-row no-gutters>
    <v-col cols="5" class="px-1">
                          <v-text-field
                            v-model="hsbc.hsbc_hotel_naam"
                            label="Hotel name"
                            dense
                          ></v-text-field>
                        </v-col>
    <v-col v-if="hsbc.huis_naam != null" cols="5" class="px-1">
                          <v-text-field
                            v-model="hsbc.huis_naam"
                            label="Acco name"
                            dense
                            readonly
                          ></v-text-field>
                        </v-col>
    </v-row>
  
  

    <v-row no-gutters>
    <v-col cols="5" class="px-1">
                          <v-text-field
                            v-model="hsbc.hsbc_hotel_adres"
                            label="Adress"
                            dense
                          ></v-text-field>
                        </v-col>
    <v-col v-if="hsbc.huis_adres != null" cols="5" class="px-1">
                          <v-text-field
                            v-model="hsbc.huis_adres"
                            label="Acco address"
                            dense
                            readonly
                          ></v-text-field>
                        </v-col>                    
    </v-row>
    
    <v-row no-gutters>
    <v-col cols="5" class="px-1">
                          <v-text-field
                            v-model="hsbc.hsbc_hotel_postcode"
                            label="Postcal code"
                            dense
                          ></v-text-field>
                        </v-col>
     <v-col v-if="hsbc.huis_postcode != null" cols="5" class="px-1">
                          <v-text-field
                            v-model="hsbc.huis_postcode"
                            label="Acco Postal code"
                            dense
                            readonly
                          ></v-text-field>
                        </v-col>                        
    </v-row>

    <v-row no-gutters>
    <v-col cols="5" class="px-1">
                          <v-text-field
                            v-model="hsbc.hsbc_hotel_plaats"
                            label="City"
                            dense
                          ></v-text-field>
                        </v-col>
      <v-col v-if="hsbc.huis_plaats != null" cols="5" class="px-1">
                          <v-text-field
                            v-model="hsbc.huis_plaats"
                            label="Acco City"
                            dense
                            readonly
                          ></v-text-field>
                        </v-col>                       
    </v-row>

     <v-row no-gutters>
    <v-col cols="5" class="px-1">
                          <v-text-field
                            v-model="hsbc.hsbc_hotel_lat"
                            label="GPS Latitude"
                            dense
                          ></v-text-field>
                        </v-col>
      <v-col v-if="hsbc.huis_lat != null" cols="5" class="px-1">
                          <v-text-field
                            v-model="hsbc.huis_lat"
                            label="Acco GPS Latitude"
                            dense
                            readonly
                          ></v-text-field>
                        </v-col>                      
    </v-row>
     <v-row no-gutters>
    <v-col cols="5" class="px-1">
                          <v-text-field
                            v-model="hsbc.hsbc_hotel_lng"
                            label="GPS Longitude"
                            dense
                          ></v-text-field>
                        </v-col>
      <v-col v-if="hsbc.huis_lng != null" cols="5" class="px-1">
                          <v-text-field
                            v-model="hsbc.huis_lng"
                            label="Acco GPS Longitude"
                            dense
                            readonly
                          ></v-text-field>
                        </v-col>                       
    </v-row>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="primary mx-2" small @click="saveHsbc">Save</v-btn>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      hsbc_encrid: null,
      hsbc: {}
    }
  },
  methods: {
    open(hsbc_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/huis/hsbc/getHsbc.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHsbc"
          },
          getHsbc: {
            hsbc_encrid: hsbc_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hsbc = res.data.getHsbc;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    saveHsbc() { 
      this.$axios
        .post("ares/json/ares/huis/hsbc/saveHsbc.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "saveHsbc"
          },
          saveHsbc: {
            hsbc_encrid: this.hsbc.hsbc_encrid,
            hsbc_hotel_naam : this.hsbc.hsbc_hotel_naam,
            hsbc_hotel_adres : this.hsbc.hsbc_hotel_adres,
            hsbc_hotel_postcode : this.hsbc.hsbc_hotel_postcode,
            hsbc_hotel_plaats : this.hsbc.hsbc_hotel_plaats,
            hsbc_hotel_lat : parseFloat(this.hsbc.hsbc_hotel_lat),
            hsbc_hotel_lng : parseFloat(this.hsbc.hsbc_hotel_lng)
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.saveHsbc.text,
              color: res.data.saveHsbc.color
            }); 
            this.dialog = false;
          }
        })
    },
  }
}
</script>

